<template>
  <div class="rounded-2xl border border-border-normal p-4 space-y-3">
    <div class="flex gap-1 items-center">
      <BaseText class="text-text-normal" type="label" size="sm">{{ title }}</BaseText>
      <div class="relative" v-if="tooltip">
        <InfoSimpleIcon class="cursor-pointer text-icon-normal tooltip-trigger" :width="20" :height="20" />
        <transition>
          <div class="tooltip-container text-center px-2 py-1 bg-neutral-800 rounded-md shadow-md cursor-default"
            style="width: 140px;">
            <BaseText type="label" size="xs" class="text-white">
              {{ tooltip }}
            </BaseText>
          </div>
        </transition>
      </div>
    </div>
    <BaseText class="text-text-muted" type="display" size="2xs">{{ getIsPrivateMode ? '•••••' : value }}</BaseText>
    <PercentageChangeIndicator :percent="percent" period-text="since last period" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PercentageChangeIndicator from './PercentageChangeIndicator.vue';
// Icons
import InfoSimpleIcon from '../globals/Icons/InfoSimpleIcon.vue';
export default {
  name: 'LensInsightCard',
  components: {
    PercentageChangeIndicator,
    InfoSimpleIcon
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: [Number, String],
      default: () => 0
    },
    percent: {
      type: Number,
      default: () => 0
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('MiscModule', ['getIsPrivateMode']),
  }
}
</script>

<style scoped>
.tooltip-container {
  pointer-events: none;
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%) translateY(0);
  opacity: 0;
  z-index: 40005;
}

.tooltip-trigger:hover+.tooltip-container {
  opacity: 1
}
</style>